var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "1280px",
      "max-width": "85%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 수정 ")])];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-2 px-4 py-md-3 px-md-5 text-md-16 grey lighten-2"
  }, [_vm._v(" 답변수정 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" mdi-close")])], 1), _c('v-card-text', {
    staticClass: "py-2 px-4 py-md-3 px-md-5"
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "답변을 입력하세요.",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small ma-n1 ma-md-0 h-100"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-file-btn', {
    staticClass: "h-100 h-md-36",
    attrs: {
      "block": "",
      "outlined": "",
      "color": "gray-9"
    },
    on: {
      "input": _vm.pushFile
    }
  }, [_vm._v("첨부")])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-btn', {
    staticClass: "h-100 h-md-36",
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("수정")])], 1)], 1)], 1)], 1), _vm.files.length ? _c('div', {
    staticClass: "mt-5"
  }, [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "column": ""
    },
    model: {
      value: _vm.files,
      callback: function callback($$v) {
        _vm.files = $$v;
      },
      expression: "files"
    }
  }, _vm._l(_vm.files, function (file) {
    return _c('v-chip', {
      key: file.name,
      attrs: {
        "outlined": "",
        "value": file
      }
    }, [_vm._v(_vm._s(file.name)), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1);
  }), 1)], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }